// Authored by Joe K
import React, { memo, useEffect } from "react";
import "./styles.scss";
import Button from "../Button/";
import { truncate } from "../../helpers/strings";
import { trackClick } from "../Api";
import Categories from "./Categories";

const Card = ({
  componentType,
  pagePath,
  label,
  title,
  author,
  description,
  categories,
  buttonCTALink,
  buttonCTAText,
  textCTALink,
  textCTAText,
  showHide,
  componentPath,
  clickTrackingEnabled,
  imagePath_product,
  showInCustomerSuccess,
  customerSuccess,
  buttonCTAText_customer,
  buttonCTALink_customer,
  index
}) => {

  Card.propTypes = {
    componentType: PropTypes.string.isRequired,
    pagePath: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    author: PropTypes.string,
    description: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.string),
    buttonCTALink: PropTypes.string,
    buttonCTAText: PropTypes.string,
    textCTALink: PropTypes.string,
    textCTAText: PropTypes.string,
    showHide: PropTypes.string.isRequired,
    componentPath: PropTypes.string.isRequired, // Add this line
    clickTrackingEnabled: PropTypes.bool.isRequired,
    showInCustomerSuccess: PropTypes.string,
    imagePath_product: PropTypes.string,
    customerSuccess: PropTypes.bool,
    buttonCTAText_customer: PropTypes.string,
    buttonCTALink_customer: PropTypes.string,
  };

  let sectionClass = "cmp-card-default";
  if (label !== "") {
    switch (label) {
      case "Free Trial":
        sectionClass = "cmp-card-display-label cmp-card-free-trial";
        break;
      case "Free":
        sectionClass = "cmp-card-display-label cmp-card-free-trial";
        break;
      case "Best Selling":
        sectionClass = "cmp-card-display-label cmp-card-best-selling";
        break;
      case "New":
        sectionClass = "cmp-card-display-label cmp-card-new";
        break;
      default:
        sectionClass = "cmp-card-display-label";
    }
  }

  const trackCtaClickInDataLayer = (e, title, type) => {
    let componentType = "Site Search";
    if (type === "product-finder") {
      componentType = "Product Finder";
    }
    window.adobeDataLayer?.push({
      event: adobeDataLayerEvents.component.searchClickthrough,
      type: componentType,
      linkDetails: {
        clickName: e.target.textContent,
        clickType: "card cta",
        clickDestination: buttonCTALink,
        clickLocation: "search result",
        card: {
          name: title,
          index: index + 1
        },
      },
    });
  };

  const trackCardClickInDataLayer = (e, title, type) => {
    let componentType = "Site Search";
    if (type === "product-finder") {
      componentType = "Product Finder";
    }
    window.adobeDataLayer?.push({
      event: adobeDataLayerEvents.component.searchClickthrough,
      type: componentType,
      linkDetails: {
        clickName: e.target.textContent,
        clickType: "card",
        clickDestination: buttonCTALink,
        clickLocation: "search result",
        card: {
          name: title,
          index: index + 1
        },
      },
    });
  };

  const renderDescription = () => {
    return <p className={`${customerSuccess ? "cmp-card-customerSuccess_description" : "cmp-card-description"}`}>{truncate(description)}</p>;
  };
  const buttonText = (customerSuccess, buttonCTAText, buttonCTAText_customer) => {
    if (customerSuccess) {
      if (buttonCTAText_customer != null && buttonCTAText_customer !== undefined) {
        return buttonCTAText_customer;
      }
      return "READ STORY";
    }
    return buttonCTAText;
  };
  const  getIndustryType = () => {
    // Find the industry where the tagId contains 'industries' and return its label
    const industry = categories.find(category => category.tagId.includes('industries'));
    return industry ? industry.label : "";
  }

  return (
    <div
      className={`cmp-card-wrapper${showHide} cmp-card-wrapper__cludo ${sectionClass}`}
    >
      <aside className="cmp-card-label cmp-card-label-heading">
        {label && <span>{label}</span>}
      </aside>
      <section className={`cmp-card ${sectionClass}-container ${customerSuccess ? 'cmp-card__customerSuccess' : ''}`}>
        <span className="cmp-card__top-border"></span>
        {showInCustomerSuccess =='true' && imagePath_product !== undefined && imagePath_product !== null && imagePath_product.length > 0 && (
        <img src={imagePath_product} className="cmp-card__csimage"></img>
        )}
        {customerSuccess ? <p className={`cmp-card-industry-type-title ${getIndustryType() ? "" : "cmp-card-null-industry-type" }`} >{getIndustryType()}</p>: ""}
        {customerSuccess ? <p
          className={`cmp-card-title cmp-card-title__customerSuccess`}
        >
          <span>{title}</span>
        </p>
        : 
        <a
          href={pagePath}
          className={`cmp-card-title`}
          onClick={(e) => {
            trackCardClickInDataLayer(e, title, componentType);
            if (clickTrackingEnabled) {
              trackClick(componentPath, pagePath);
            }
          }}
        >
          <span>{title}</span>
        </a>  
      }
        {author && <p className="cmp-card-author">{author}</p>}
        {description && renderDescription()}
        <div className="flexible"></div>
        {((buttonCTAText && buttonCTALink) || (buttonCTAText_customer && buttonCTALink_customer)) && (
          <section
            className={`cmp-card-button-cta ${
              !textCTAText ? "big-padding-bottom" : ""
            }`}
          >
            <a
                href={customerSuccess ? buttonCTALink_customer : buttonCTALink}
                className="cmp-button-link"
                onClick={(e) => {
                  trackCtaClickInDataLayer(e, title, componentType);
                  if (clickTrackingEnabled) {
                    trackClick(componentPath, pagePath);
                  }
                  handleClick(e);
                }}
            >
              {buttonText(customerSuccess, buttonCTAText, buttonCTAText_customer)}
            </a>
          </section>
        )}
        {textCTALink && textCTAText && customerSuccess != true && (
          <section className="cmp-card-text-cta">
            <a
              href={textCTALink}
              className="cmp-card-link"
              onClick={(e) => {
                trackCtaClickInDataLayer(e, title, componentType);
                if (clickTrackingEnabled) {
                  trackClick(componentPath, pagePath);
                }
              }}
            >
              {textCTAText}
            </a>
          </section>
        )}
      </section>
    </div>
  );
};

export default memo(Card);
